import { getPrivateActionId } from './actionCreator';
import { subscribe } from './dispatcher';
export default function orchestrator(actionCreator, target) {
    var actionId = getPrivateActionId(actionCreator);
    if (!actionId) {
        throw new Error('Orchestrators can only subscribe to action creators.');
    }
    subscribe(actionId, target);
    return target;
}
